const DEFAULT_DELAY = 6000;
const TRANSITION_SPEED = 450;

const REDUCED_MOTION_SPEED = 1;

class SectionPromoBar extends HTMLElement {
  connectedCallback() {
    this.viewport = this.querySelector(".swiper");
    this.slides = this.querySelectorAll(".swiper-slide");
    this.toggle = this.querySelector("[data-promo-bar-toggle]");
    this.toggleLabel = this.querySelector("[data-promo-bar-toggle-label]");
    this.prev = this.querySelector("[data-promo-bar-prev]");
    this.next = this.querySelector("[data-promo-bar-next]");

    if (!this.viewport || this.slides.length < 2) return;

    window.loadSwiper.then((swiperLib) => this.initSwiper(swiperLib));
  }

  disconnectedCallback() {
    this.swiper?.destroy(true, true);
  }

  initSwiper({ Swiper, Autoplay, EffectCreative }) {
    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;

    this.swiper = new Swiper(this.viewport, {
      modules: [Autoplay, EffectCreative],
      slidesPerView: 1,
      speed: reducedMotion ? REDUCED_MOTION_SPEED : TRANSITION_SPEED,
      loop: true,
      allowTouchMove: false,
      effect: "creative",
      creativeEffect: {
        limitProgress: 1,
        prev: { translate: [0, "-100%", 0], opacity: 0 },
        next: { translate: [0, "100%", 0], opacity: 0 },
      },
      autoplay: {
        delay: DEFAULT_DELAY,
        disableOnInteraction: false,
      },
    });

    this.prev?.addEventListener("click", () => this.step("slidePrev"));
    this.next?.addEventListener("click", () => this.step("slideNext"));

    if (!this.toggle) return;

    this.setToggleState(true);
    this.toggle.addEventListener("click", () => this.handleToggle());
  }

  step(method) {
    if (!this.swiper) return;

    this.swiper[method]();

    if (this.swiper.autoplay?.running) {
      this.swiper.autoplay.start();
    }
  }

  handleToggle() {
    if (!this.swiper?.autoplay) return;

    const playing = this.swiper.autoplay.running;

    if (playing) {
      this.swiper.autoplay.stop();
    } else {
      this.swiper.autoplay.start();
    }

    this.setToggleState(!playing);
  }

  setToggleState(playing) {
    this.dataset.playing = playing ? "true" : "false";

    if (!this.toggleLabel) return;

    this.toggleLabel.textContent = playing
      ? this.toggle.dataset.pauseLabel
      : this.toggle.dataset.playLabel;
  }
}

if (!customElements.get("section-promo-bar")) {
  customElements.define("section-promo-bar", SectionPromoBar);
}
